@if (controls.length) {
    <div [ngClass]="containerClass">
        @for (flexGroup of controls; track $index; let flexIndex = $index) {
            <div [ngClass]="columnClass" [formGroup]="flexGroup">
                <p-inputGroup>
                    <p-iftaLabel>
                        @if (isBoolean(flexIndex)) {
                            <p-select formControlName="value"
                                [options]="booleanOptions"
                                optionLabel="label"
                                optionValue="value"
                                styleClass="w-full"></p-select>
                        } @else if (isDate(flexIndex)) {
                            <input type="date" pInputText formControlName="value" class="w-full" />
                        } @else if (isDateTime(flexIndex)) {
                            <input type="datetime-local" pInputText formControlName="value" class="w-full" />
                        } @else if (isNumeric(flexIndex)) {
                            <input type="number" pInputText formControlName="value" class="w-full"
                                [attr.step]="getNumericStep(flexIndex)" />
                        } @else {
                            <input type="text" pInputText formControlName="value" class="w-full" />
                        }
                        <label>{{ getLabel(flexIndex) }}</label>
                    </p-iftaLabel>
                </p-inputGroup>
                @if (shouldShowError(flexIndex)) {
                    <small class="p-error">{{ getErrorMessage(flexIndex) }}</small>
                }
            </div>
        }
    </div>
}
